//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name:'ShockIndex',
  data() {
    return {
      defaultJson:{
        "Index": "指数",
        "Systolic Blood Pressure": "收缩压",
        "Heart Rate": "心率",
        "Shock is probable": "休克可能"
      },
      form:{
        sbp:'',
        hr:'',
      },
      contentDescription:'',
      hasScore:false,
      disabled:false,
      dataList1:[
        {value:"0",name:'男'},
        {value:"5",name:'女'},
      ],
      res:'...',
    }
  },
  rqed () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else { 
            if (form[key]=='---') {
              flag = false
            } else {  
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {
        // hr/sbp
        let res =  form.hr/form.sbp
        self.res = res.toFixed(1)
        
        self.hasScore = true
        return String(self.res)
      }
    }
  },
  
  
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Card/ShockIndex.vue